import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'semantic-ui-react';
import API from '../utils/network';
import { isNullOrUndefined, stringIsNumber, stringIsNullOrUndefinedOrBlank } from '../utils/siteFunctions';
import logo from '../assets/images/simplicity-logo.svg';
import { setUser, refreshCustomerClientPortalSettings, addPopupMessage } from '../store/reducers/ui/actions';
import Button from '../components/elements/Button';
import useAuth from '../utils/customHooks/useAuth';
import cookie from 'cookie_js';
import SimplicityIcon from '../assets/images/Simplicity-Icon-Dark.png';

const LoginPage = () => {
	/// Hooks
	const dispatch = useDispatch();
	const auth = useAuth();
	const location = useLocation();

	/// Global State
	const customer = useSelector(state => state.ui.customer);
	const user = useSelector(state => state.ui.user);

	/// Local State
	const [ pinTextBoxValue, setPinTextBoxValue ] = useState('');
	const [ usernameTextBoxValue, setUsernameTextBoxValue ] = useState('');
	const [ passwordTextBoxValue, setPasswordTextBoxValue ] = useState('');
	const [ pinTextBoxError, setPinTextBoxError ] = useState(false);
	const [ usernameTextBoxError, setUsernameTextBoxError ] = useState(false);
	const [ passwordTextBoxError, setPasswordTextBoxError ] = useState(false);
	const [ errorMessage, setErrorMessage ] = useState<string | undefined>(undefined);

	/// Local Variables
	const textboxStyle = {
		width: '20em'
	};
	// temp // remove this comment
	/// Effects
	useEffect(() => {
		// check if the pin parameter is filled
		const urlParams = new URLSearchParams(window.location.search);

		let usePin = false;
		if (urlParams.has('pin')) {
			const pinParam:string = urlParams.get('pin') || '';
			if (stringIsNumber(pinParam)) {
				dispatch(refreshCustomerClientPortalSettings(parseInt(pinParam)));
				usePin = true;
			}
		}

		if (!usePin && isNullOrUndefined(customer.pin))
			dispatch(refreshCustomerClientPortalSettings());
	}, [dispatch, customer.pin]);

	/// Event Handlers
	const handleLoginClick = e => {
		e.preventDefault();

		let failed = false;

		if (isNullOrUndefined(customer.pin) && (isNullOrUndefined(pinTextBoxValue) || !stringIsNumber(pinTextBoxValue))) {
			setPinTextBoxError(true);
			failed = true;
		}

		if (!usernameTextBoxValue) {
			setUsernameTextBoxError(true);
			failed = true;
		}

		if (!passwordTextBoxValue) {
			setPasswordTextBoxError(true);
			failed = true;
		}

		if (!failed)
			auth.signIn(customer.pin || parseInt(pinTextBoxValue), usernameTextBoxValue, passwordTextBoxValue, () => {
				if (stringIsNullOrUndefinedOrBlank(cookie('simplicity-client-portal-jwt'))) {
					setUsernameTextBoxError(true);
					setPasswordTextBoxError(true);
					setErrorMessage('Invalid Username or Password');
				}
			});
	};

	const handlePinTextBoxChange = (e, { value }) => {
		setPinTextBoxValue(value);
		setPinTextBoxError(false);
	};

	const handleUsernameTextBoxChange = (e, { value }) => {
		setUsernameTextBoxValue(value);
		setUsernameTextBoxError(false);
		setErrorMessage(undefined);
	};

	const handlePasswordTextBoxChange = (e, { value }) => {
		setPasswordTextBoxValue(value);
		setPasswordTextBoxError(false);
		setErrorMessage(undefined);
	};

	/// Render
	return (
		<div
			style={{
				display: 'grid',
				gridAutoRows: '1fr max-content 1fr',
				alignItems: 'center',
				height: '100%'
			}}
		>
			<div />
			<div
				style={{
					display: 'grid',
					backgroundColor: customer.secondaryColor,
					padding: '2em',
					width: '64em',
					minHeight: '29em',
					justifySelf: 'center'
				}}
			>
				<div style={ { 
					display: 'grid',
					gridTemplateColumns: '3fr 4fr',
					boxShadow: 'rgba(0, 0, 0, 0.6) -1px 5px 10px'
				} }>
					<div
						style={{
							backgroundColor: customer.primaryColor,
							color: '#ffffff',
							display: 'inline-flex',
							justifyContent: 'center',
							alignItems: 'center',
							flexDirection: 'column',
							padding: '0 2em'
						}}
					>
						<img src={customer.logoUrl} style={{ maxWidth: '19em' }} />
					</div>
					<div
						style={{
							display: 'flex',
							backgroundColor: '#ffffff',
							alignItems: 'center',
							justifyContent: 'center',
							padding: '2em'
						}}

						onSubmit={handleLoginClick}
					>
						<form
							style={{
								display: 'flex',
								flexFlow: 'column',
								alignItems: 'flex-start'
							}}
						>
							<h2>Welcome to the {(customer.customerName || 'Simplicity Collect')} Client Portal</h2>
							{ isNullOrUndefined(customer.pin) &&
								<>
									<div className="textbox-label">Company Pin</div>
									<Input style={textboxStyle} onChange={handlePinTextBoxChange} value={pinTextBoxValue} error={pinTextBoxError} />
								</>
							}
							<div className="textbox-label">Username</div>
							<Input style={textboxStyle} onChange={handleUsernameTextBoxChange} value={usernameTextBoxValue} error={usernameTextBoxError} />
							<div className="textbox-label">Password</div>
							<Input type="password" style={textboxStyle} onChange={handlePasswordTextBoxChange} value={passwordTextBoxValue} error={passwordTextBoxError} />
							{errorMessage && <div style={{ color: '#9f3a38' }}>{errorMessage}</div> }
							<Button
								primary
								style={{
									textTransform: 'uppercase',
									marginTop: '3em'
								}}
							>
								Sign In
							</Button>
						</form>
					</div>
				</div>
			</div>
			<a href="https://www.simplicitycollectionsoftware.com/" target="#" style={{ display: 'flex', justifySelf: 'right', alignSelf: 'end', alignItems: 'center', padding: '.5em' }}>
				Powered by <img src={SimplicityIcon} /> SimplicityCollect
			</a>
		</div>
	);
};

export default LoginPage;